export default {
  edit_selection: 'Editează selecția',
};
